import { FormField } from "@/ds";
import styles from "../../etapa-obra.module.scss";
import { Hint } from "../hint";
import type { FieldProps } from "./types-field";

/** Rótulo, ⓘ, controle e erro: o `FormField` liga o `<label for>` e o `aria-*` ao controle. */
export function FieldView({ label, error, disabled, hint, wide, children }: FieldProps) {
  return (
    <FormField.Root
      className={`${styles.field} ${wide ? styles.wide : ""}`}
      error={error}
      disabled={disabled}
    >
      <div className={styles.labelRow}>
        <FormField.Label>{label}</FormField.Label>
        {hint && <Hint {...hint} tooltipClassName={hint.tooltipClassName ?? ""} />}
      </div>
      <FormField.Control>{children}</FormField.Control>
      <FormField.Error />
    </FormField.Root>
  );
}
